import React from 'react';
const facts = [{
  value: '6',
  label: 'Volumes'
}, {
  value: '142',
  label: 'Practice cards'
}, {
  value: '5',
  label: 'Free bonuses'
}, {
  value: '3',
  label: 'Formats · 5v5 · 7v7 · tackle'
}];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-263" data-mp="29up767vk3otf">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-264" data-mp="25t3x0uaepomx">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-265" data-mp="25qr980hywk1y">
          {facts.map(fact => <div key={fact.label} className="bg-navy px-4 py-5 text-center" data-id="element-266" data-mp="2xl3000lytrp2">
              <div className="font-display text-3xl leading-none text-gold sm:text-4xl" data-id="element-267" data-mp="2thwx92y2ainc">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-268" data-mp="2oitr1f6ci6ds">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}